import { HelpSection } from 'legacy/lut/components/widgets/public/partner360/helpButton/enums/HelpSection'

export const corePrintKbaseLinks = {
  [HelpSection.ProgramOfferings]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1588/aid/4222',
  [HelpSection.Completeness]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1650/aid/4636',
  [HelpSection.BasicInfo]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1650/aid/4642',
  [HelpSection.ContactInfo]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1650/aid/4643',
  [HelpSection.HpContact]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1650/aid/4650',
  [HelpSection.TranslationFactors]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1650/aid/4645',
  [HelpSection.DeviceInfo]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1650/aid/4646',
  [HelpSection.MarketInfo]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1650/aid/4647',
  [HelpSection.FinancialAndSOB]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1650/aid/4648',
  [HelpSection.TopDeal]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1650/aid/4649',
  [HelpSection.LongTerm]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1650/aid/4652',
  [HelpSection.KeyInitiatives]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1650/aid/4813',
  [HelpSection.Bridges]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1650/aid/4654',
  [HelpSection.MDFPlanning]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1650/aid/4656',
  [HelpSection.Graphs]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1650/aid/4657',
  [HelpSection.MasterDealer]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1650/aid/4658',
  [HelpSection.PBMAcknowledgment]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1650/aid/4821',
  [HelpSection.ManagerAcknowledgment]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1650/aid/4822',
  [HelpSection.PartnerAcknowledgment]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1650/aid/4823',
  [HelpSection.HistoryAcknowledgment]:
    'https://hpscoutso.spa.hpcloud.hp.com/page/k-base/cat/432-1587-1650/aid/4824',
}
